import { FC, useCallback, useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import Button from 'components/parts/button/button'
import Recommendations from 'containers/recommendations/recommendations'
import RecommendationContext from 'context/recommendationContext'

import { Option } from 'constants/search-data/library-search-data'
import { Pathname } from 'constants/data'
import { skeletonFour } from 'constants/skeleton-data'
import { BASE_URL } from 'constants/url'
import { getAxiosArr } from 'pages/api/axios'
import { IEventCard } from 'store/data-types'
import { originSubscribe, originFWebinar } from 'utils/analytics/webinars/webinar_future'

import styles from './no-target-cards.module.scss'

interface INoTargetCards {
  selectedOption: string
}

const InitData = {
  cards: (skeletonFour as IEventCard[]) || (skeletonFour as any),
  isLoaded: false,
}

const NoTargetCards: FC<INoTargetCards> = ({ selectedOption }: INoTargetCards) => {
  const [recommendations, setRecommend] = useState(InitData)

  const router = useRouter()

  const text =
    selectedOption === Option.article ? (
      <>
        К сожалению, статей по данной специальности еще не было.
        <br />
        Предлагаем вам ознакомиться со статьями по другим специальностям😊
      </>
    ) : selectedOption === Option.video ? (
      <>
        К сожалению, лекций по данной специальности еще не было.
        <br />
        Предлагаем вам ознакомиться с лекциями по другим специальностям😊
      </>
    ) : (
      ''
    )

  const btnText =
    selectedOption === Option.article ? (
      <>Показать все статьи</>
    ) : selectedOption === Option.video ? (
      <>Показать все лекции</>
    ) : (
      ''
    )

  const goToAllCards = useCallback(() => {
    const route = selectedOption === Option.article ? 'article' : 'video'

    router.push({ pathname: `/${Pathname.LIBRARY}/${route}`, query: undefined }, undefined, {
      shallow: true,
    })
  }, [selectedOption])

  useEffect(() => {
    const getData = async () => {
      const url = `${BASE_URL.RECOMMENDATION}?materialType=article&limit=2`
      const cards = await getAxiosArr(url)
      setRecommend({ cards, isLoaded: true })
    }
    getData()
  }, [])

  if (!text && !btnText) return null
  console.log(btnText)

  return (
    <div className={styles.noCards}>
      <p className={styles.paragraph}>{text}</p>
      <div className={styles.button} onClick={goToAllCards}>
        <Button>{btnText}</Button>
      </div>

      <RecommendationContext.Provider
        value={{ recommendations, setRecommend, materialType: 'article' }}
      >
        <div className={styles.recommendations}>
          <Recommendations
            AData={{
              originSub: originSubscribe.NOORIGIN,
              originClick: originFWebinar.NOORIGIN,
            }}
            noFixedWidth
          />
        </div>
      </RecommendationContext.Provider>
    </div>
  )
}

export default NoTargetCards
